﻿/**
 * Responsive Tables
 * 
 * @class rlResponsiveTables
 * @memberOf jQuery.fn
 */

(function ($) {
   $.fn.rlResponsiveTables = function () {

        //make table(s) on page follow bootstraps responsive methodology
        $("#main-content table").wrap("<div class='table-responsive'></div>");
        $(".table-responsive table").addClass('table');

        //force 'simple' version onto certain blocks..
        const PlaceHolderTable = $('.placeholderblock table')
        PlaceHolderTable.addClass('simple');
        PlaceHolderTable.find('tr, td').removeAttr('style').removeAttr('width');
        PlaceHolderTable.removeAttr('border');

        //eliminate inline styling
        $(".table-responsive table").attr('style', '');
        $(".table-responsive table td, .table-responsive table th").attr('width', '');

        //add AA table accessibility standards
        $(".table-responsive table thead td, .table-responsive table thead th").attr('scope', 'col');
        $(".table-responsive table tbody tr td:first-of-type").attr('scope', 'row');

        //switch valign to vertical-align to override stylesheet
        $("table [valign='middle']").css("vertical-align", "middle");
        $("table [valign='bottom']").css("vertical-align", "bottom");


        //override inline border on tables
        $("table").attr("border", "0");

        //remove tbody, thead, tfoot
        $('thead').contents().unwrap();
        $('tbody').contents().unwrap();
        $('tfoot').contents().unwrap();

        var pagetablecounter = 0;
        $(".table-responsive table").each(function () {

            //Add ID to each table on screen
            pagetablecounter++;
            $(this).attr("id", "table_" + pagetablecounter);

            //is this a data or simple table type? (as chosen by the CMS editor)
            if (!$(this).hasClass('simple')) {
                $(this).addClass('data');  
            }

        });

        //move the caption outwith the tablet (if there is one)
        //this stops the caption interfering with the matching tablet row height maths
        $(".table-responsive").each(function () {
            var tablecaption = $(this).find('caption'); //var the caption
            if (tablecaption.length) {
                $(tablecaption).detach().appendTo($(this)); //detach and append
                $(this).addClass('withcaption'); //addclass to parent for layout purpose
            }
        });

        //when user scrolls table, hide 'swipe to view' swipetoview graphic
        $(".table-responsive").scroll(function () {
            $(this).parent(".overflowing").find('.swipetoview').addClass("hideswipe");
            $(this).find('.swipetoview').addClass("hideswipe");
        });

        function tablebuilder() {
            $(".table-responsive").each(function () {

               if($(window).width() <= 768) {
                    if ($(this).children('table.data').width() >= $(this).width()) {

                        //add overflow functionality to table and its parent
                        $(this).children("table.data:first-of-type").addClass("overflow");
                        $(this).find("table.data tr :first-child").addClass("firstofrow");
                        $('.firstofrow').not('td, th').removeClass('firstofrow');

                        //wrap table in appropriate container
                        if ($(this).parent().hasClass("overflowing")) {}
                        else {
                            $(this).wrap("<div class='overflowing'></div>");
                            //append swipe swipetoview into overflowing parent
                            $(this).children(".swipetoview").remove();
                            $(this).parent(".overflowing").append("<div class='swipetoview'>Swipe to view</div>");                            
                        }

                        //clone original table
                        if ($(this).parent().children('table.data').hasClass('cloned')) {}
                        else {
                           const tablesparentid = $(this).children('table.data').attr('id');
                           $(this).children('table.data').clone().removeClass("overflow").addClass('cloned').attr("id", "cloned" + tablesparentid).attr('aria-hidden', 'true').appendTo($(this).parent());
                        }                       

                        //remove unneeded elements from cloned table (for absolute first column positioning)
                        $('table.data.cloned td, table.cloned th, table.data.cloned caption').not('.firstofrow').remove();

                        //hide first column in original table and show first column in cloned table
                        $('table.data.overflow:first-of-type .firstofrow').hide().attr('aria-hidden', 'false');
                        $('table.data.cloned .firstofrow').show();
                        $('table.data tr').attr('style', '');
                        $(this).removeClass('hideswipe');
                    }
                }
                else {
                    //delete clone and reset table if user goes from mobile to tablet > screen size
                    if ($(this).next().next('.table.data').hasClass('cloned')) {
                        $(this).next().next('table.data.cloned').remove();
                        $('table.data.overflow:first-of-type .firstofrow').show().removeAttr('aria-hidden');
                        $(this).children('table.data').removeClass('overflow');
                        $(this).parent().children('.swipetoview').remove();
                        $(this).children('table.data').attr('style', '');
                        $(this).children('table.data').find('td, th').removeClass('firstofrow');
                        $(this).unwrap();
                    }  
               }

               if ($(this).children('table').hasClass('simple')) {
                   addinswipetoview(this);
               }

               if ($(window).width() > 768 && $(this).children('table').hasClass('data')) {
                   addinswipetoview(this);   
               }

               function addinswipetoview(thiselement) {
                   var scrollwidth = $(thiselement).prop('scrollWidth'),
                   thiswidth = $(thiselement).width(),
                   thiswidthround = Math.round(thiswidth);

                   if(scrollwidth > thiswidthround) {
                       if ($(thiselement).children('.swipetoview').length) {
                       }
                       else {
                           $(thiselement).append("<div class='swipetoview' aria-hidden='true'>Swipe to view</div>");
                       }
                   }
                   else {$(thiselement).children('div.swipetoview').remove();}

                   $('table.data tr').attr('style', '');
               }

               ///change wording from 'SWIPE to view' to 'SCROLL to view' if not on touchevent device
               if (Modernizr.touchevents) {}
               else {
                   $(this).find('div.swipetoview').html('Scroll to view');
                   $(this).parent(".overflowing").find('.swipetoview').html('Scroll to view');
               }

            });
            //count how many rows a table has (changes size of swipetoview if the table is shorter than 200px)
            $(".table-responsive table").each(function () {
                var tablerowcounter = $(this).height();
                if (tablerowcounter < 200) {
                    $(this).parent(".table-responsive").find('.swipetoview').addClass('smlswipe').attr('aria-hidden', 'true'); //simple table type
                    $(this).parent(".table-responsive").next('.swipetoview').addClass('smlswipe').attr('aria-hidden', 'true'); //data table type
                }
            });
        }

        //balance table rows on both tables (to make sure the biggest is captured)
        function alignTableRowHeights() {
            $('.cloned tr, .overflow tr').attr('style', '');
            $('.data tr').attr('height', '');

            $('.overflowing').each(function () {
                //which table.overflow or table.clone table row has the greatest height?
                var tablerowcount = 1;
                var clonedarray = [];
                var overflowarray = [];

                $(this).children('table.cloned').find('tr').each(function () {
                    var clonedrow = $(this).height();
                    clonedarray.push(clonedrow);
                });
                $(this).children('.table-responsive').children('table.overflow').find('tr').each(function () {
                    var overflowrow = $(this).height();
                    overflowarray.push(overflowrow);
                });

                for (var i in clonedarray) {
                    if (clonedarray[i] >= overflowarray[i]) {
                        $(this).children('table.cloned').find('tr:nth-child(' + tablerowcount + ')').attr('height', clonedarray[i]);
                        $(this).children('.table-responsive').children('table.overflow').find('tr:nth-child(' + tablerowcount + ')').attr('height', clonedarray[i]);
                    }
                    else {
                        $(this).children('table.cloned').find('tr:nth-child(' + tablerowcount + ')').attr('height', overflowarray[i]);
                        $(this).children('.table-responsive').children('table.overflow').find('tr:nth-child(' + tablerowcount + ')').attr('height', overflowarray[i]);
                    }

                    tablerowcount++;
                }
                var tablerowcount = 1;

            });
        }

        //run table builder functions on doc ready
        tablebuilder();
        alignTableRowHeights();

        //recheck table builder functions on window resize (uses 150ms delay function from rl-Global.js)
        $(window).on('resize-end', function () {
            tablebuilder();
            alignTableRowHeights();
        });
        
    }
}(jQuery));